const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconSubir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.04 17.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.54,17H.5a.5.5,0,0,1-.5-.5V10.8a.5.5,0,0,1,1,0V16H19V10.8a.5.5,0,0,1,1,0v5.74A.5.5,0,0,1,19.54,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.6,3.58a.47.47,0,0,1-.35-.15L10,1.2,7.79,3.43a.5.5,0,0,1-.7,0,.5.5,0,0,1,0-.71L9.67.14a.5.5,0,0,1,.7,0L13,2.72a.5.5,0,0,1,0,.71A.47.47,0,0,1,12.6,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,12.22a.5.5,0,0,1-.5-.5V1a.5.5,0,1,1,1,0V11.72A.5.5,0,0,1,10,12.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubir);
export default __webpack_public_path__ + "static/media/icon_subir.e3d59e5044c6fba972f976c96195b564.svg";
export { ForwardRef as ReactComponent };